"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_FUNCTION_DELAY = exports.MAX_ANG_STREAM_SEARCH_RESULTS = exports.MAX_ANG_FACETS_RESULTS = void 0;
const MAX_ANG_STREAM_SEARCH_RESULTS = exports.MAX_ANG_STREAM_SEARCH_RESULTS = 500;
const MAX_ANG_FACETS_RESULTS = exports.MAX_ANG_FACETS_RESULTS = 50;
const SEARCH_FUNCTION_DELAY = exports.SEARCH_FUNCTION_DELAY = 300;
//# sourceMappingURL=constants.js.map